<script>
import Layout from '@layouts/main.vue';
import { authMethods, authComputed } from '@state/helpers';
import appConfig from '@src/app.config';

export default {
  page: {
    title: 'Forgot Pass',
    meta: [{ name: 'description', content: 'The Forgot Pass page.' }],
  },
  components: { Layout },
  data() {
    return {
      email: '',
      resettingPassword: false,
      resetError: '',
      resetSuccess: '',
    };
  },
  computed: {
    ...authComputed,
    placeholders() {
      return appConfig.NODE_ENV === 'production'
        ? { email: 'Email' }
        : {
            email: `Email`,
          };
    },
  },
  methods: {
    ...authMethods,
    emailReset() {
      this.resettingPassword = true;
      this.resetPassword({
        resetType: this.$route.params.type,
        email: this.email,
      })
        .then((response) => {
          if (response.success) {
            this.resetSuccess = response.message;
          } else {
            this.resetError = response.message;
          }
          this.resettingPassword = false;
        })
        .catch((error) => {
          this.resetError = error.message;
          this.resettingPassword = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="container-wrapper clients login">
      <div class="content-wrapper">
        <form class="login-form" @submit.prevent="emailReset">
          <div class="form-header">
            <h1>Forgot Password</h1>
            <pre>Let's help you get your password reset!</pre><br />
          </div>
          <label for="username">Please Enter your Email below</label>
          <BaseInputText
            v-model="email"
            name="username"
            :placeholder="placeholders.email"
          />
          <BaseButton
            :disabled="resettingPassword"
            type="submit"
            class="btn-secondary"
          >
            <BaseIcon v-if="resettingPassword" name="sync" spin />
            <span v-else>Reset</span>
          </BaseButton>
          <p v-if="resetError">
            There was an error attempting the password reset. Contact Support.
          </p>
          <p v-if="resetSuccess">
            Email succesfully sent. Check your inbox.
          </p>
        </form>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';
.login-form {
  background-color: $color-white;
  border-radius: 8px;
  box-shadow: 0 2px 18px rgba($color-gray-wo-rgb, 0.25);
  margin: 0 auto;
  min-width: 500px;
  padding: 7rem;
  text-align: center;
  width: 50%;

  label {
    display: block;
    margin: 0;
    text-align: left;
  }
}

.login {
  background-color: $color-off-white-one;
}

.login-footer {
  align-items: flex-start;
  display: flex;
  .terms {
    flex-basis: 50%;
    flex-grow: 2;
    font-size: 1.4rem;
    line-height: 2rem;
    text-align: left;
    a {
      color: $color-action;
      letter-spacing: unset;
      text-decoration: none;
    }
  }
}

.form-header {
  pre {
    font-family: $base-font-family;
    font-size: 1.2rem;
    font-weight: 800;
    letter-spacing: 0.1px;
    line-height: 2.2rem;
    margin: 0;
    text-align: left;
    text-transform: uppercase;
  }
  h1 {
    font-family: $base-font-family;
    font-size: 4.8rem;
    font-weight: black;
    letter-spacing: -0.76px;
    line-height: 5.2rem;
    margin: 0;
    margin-bottom: 24px;
    text-align: left;
  }
}
</style>
